import React from 'react';
import type { MemorySidebarUIProps } from 'redux/selectors/timeline.memories';
import { MemoryEmptyState } from './MemoryEmptyStates';
import styles from './MemoryTimelineEmptyState.module.scss';

interface Props {
  ui: MemorySidebarUIProps;
}

export function MemoryTimelineEmptyState(props: Props) {
  const { ui } = props;

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <MemoryEmptyState emptyState={ui.emptyStateType} isToday={ui.isToday} />
      </div>
    </div>
  );
}
